/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SparzeitUmbuchungDto } from '../../models/sparzeit-umbuchung-dto';

export interface GetAllSparzeitUmbuchungen$Json$Params {
  date?: string;
  mitarbeiterId?: string;
}

export function getAllSparzeitUmbuchungen$Json(http: HttpClient, rootUrl: string, params?: GetAllSparzeitUmbuchungen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SparzeitUmbuchungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllSparzeitUmbuchungen$Json.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SparzeitUmbuchungDto>>;
    })
  );
}

getAllSparzeitUmbuchungen$Json.PATH = '/v1/sparzeitumbuchung';
